import {
  ConnectionListResult,
  DatabasesQueryByIds,
  DatabasesQueryByIdsGql,
  DatabasesQueryByIdsNodes,
  DatabasesQueryByIdsVariables,
} from '@tableau/data-catalog-client-components';
import { defaultMemoize } from 'reselect';

import { ISliceable } from '../../ts/models/ISliceable';
import { catalogApolloClient } from '../CatalogApolloClient';
import { BaseGraphQLResourceQuery } from './BaseGraphQLResourceQuery';
import { getInFilter } from './CatalogFilterClauseHelpers';
import { makeSliceableFactoryForGraphQLQuery } from './GraphQLSliceable';

const getSliceableFactorySingleton = defaultMemoize(() => {
  return makeSliceableFactoryForGraphQLQuery<
    DatabasesQueryByIdsNodes,
    DatabasesQueryByIdsNodes,
    DatabasesQueryByIdsVariables,
    DatabasesQueryByIds
    >(
    {
      queryGql: DatabasesQueryByIdsGql,
      selectConnectionListResult: function selectConnectionListResult(resultData: DatabasesQueryByIds): ConnectionListResult<DatabasesQueryByIdsNodes> | null {
        return resultData && resultData.databasesConnection ;
      },
      mapResultNode: function mapResultNode(database: DatabasesQueryByIdsNodes): DatabasesQueryByIdsNodes {
        return database;
      }
    },
    catalogApolloClient
  );
});

export class DatabasesByIdsGraphQLResourceQuery
  extends BaseGraphQLResourceQuery<DatabasesQueryByIdsNodes> {

  protected makeSliceable(): ISliceable<DatabasesQueryByIdsNodes> {
    const databaseIds = getInFilter(this.getFilters());
    const partialQueryVariables = { databaseIds: databaseIds as string[] };
    return getSliceableFactorySingleton()(partialQueryVariables);
  }
}
